export enum Service {
  EMS = 'ems',
  HTTP = 'http',
  NMOS = 'nmos',
  ONVIF = 'onvif',
  PASSTHROUGH = 'passthrough',
  PREVIEW = 'preview',
  RTSP = 'rtsp',
  SNMP = 'snmp',
  SSH = 'ssh',
  TELNET = 'telnet',
}
